import type { ReactNode } from "react";

type Tone = "accent" | "neutral" | "error";

export function Callout({
  tone = "accent",
  children,
  role,
}: {
  tone?: Tone;
  children: ReactNode;
  role?: "alert" | "status";
}) {
  const cls = tone === "accent" ? "callout" : `callout callout--${tone}`;
  return (
    <div className={cls} role={role}>
      {children}
    </div>
  );
}
